import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid2,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { GKModal } from "components";
import { useState } from "react";
import toast from "react-hot-toast";
import axiosInstance from "utils/axiosInstance";

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
  invoice: any;
}

const SendInvoiceModal = (props: Props) => {
  const { open, setOpen, invoice } = props;

  // Same API the billing page uses: advisor phone in the URL, billing id in the body
  const { mutate: handleSendInvoice, isLoading } = useMutation({
    mutationKey: ["SEND_ADVISOR_INVOICE"],
    mutationFn: () =>
      axiosInstance.post(`/super_admin/${invoice?.phone}/send-invoice/`, {
        billingId: invoice?.billing,
      }),
    onSuccess: (response) => {
      toast.success(response?.data?.message || "Invoice Sent Successfully");
      setOpen(false);
    },
    onError: (error: any) => {
      toast.error(error?.response?.data?.message || "Something went wrong");
    },
  });

  const canSend = !!invoice?.phone && !!invoice?.billing;

  // Send only goes out once the email is ticked
  const [isEmailChecked, setIsEmailChecked] = useState(false);

  return (
    <GKModal
      open={open}
      setOpen={setOpen}
      modalTitle="Send Invoice"
      width="600px"
      footer={
        <Grid2 container justifyContent={"flex-end"} gap={1}>
          <Button variant="outlined" onClick={() => setOpen(false)}>
            Cancel
          </Button>
          <Button
            variant="contained"
            disabled={!canSend || !isEmailChecked || isLoading}
            onClick={() => handleSendInvoice()}
          >
            {isLoading ? "Sending..." : "Send"}
          </Button>
        </Grid2>
      }
    >
      <Grid2 container spacing={2}>
        <Grid2 size={12}>
          <TableContainer
            sx={{ border: "1px solid var(--neutral-100)", borderRadius: 2 }}
          >
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 600 }}>Name</TableCell>
                  <TableCell sx={{ fontWeight: 600 }}>Email</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>{invoice?.advisorName || "-"}</TableCell>
                  <TableCell>
                    {/* Clicking the email also toggles the checkbox */}
                    <FormControlLabel
                      disabled={!invoice?.email}
                      label={invoice?.email || "Email not available"}
                      sx={{
                        m: 0,
                        gap: 1,
                        "& .MuiFormControlLabel-label": { fontSize: 14 },
                      }}
                      control={
                        <Checkbox
                          color="primary"
                          checked={isEmailChecked}
                          onChange={(event) =>
                            setIsEmailChecked(event.target.checked)
                          }
                          sx={{
                            p: 0.5,
                            borderRadius: "6px",
                            "& .MuiSvgIcon-root": { fontSize: 24 },
                          }}
                        />
                      }
                    />
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default SendInvoiceModal;
